var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn-icon',{attrs:{"icon":_vm.value ? 'eye-off' : 'eye',"title":_vm.$t(_vm.value ? 'btn.hideDeleted' : 'btn.showDeleted'),"color":"accent"},on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }